/* CAPINI NAV — chips da vitrine e categorias do painel lateral · 23/09/2026 */
(function () {
  function init() {
    document.querySelectorAll('[data-capini-vitrine]').forEach(function (v) {
      if (v.dataset.ok) return; v.dataset.ok = '1';
      var chips = v.querySelectorAll('.capini-chip'), panels = v.querySelectorAll('[data-series-panel]');
      chips.forEach(function (c) {
        c.addEventListener('mouseenter', pick); c.addEventListener('click', pick); c.addEventListener('focus', pick);
        function pick() {
          chips.forEach(function (o) { o.classList.toggle('is-on', o === c); o.setAttribute('aria-selected', o === c ? 'true' : 'false'); });
          panels.forEach(function (p) { p.hidden = p.getAttribute('data-series-panel') !== c.getAttribute('data-series'); });
        }
      });
    });
    document.querySelectorAll('[data-capini-side]').forEach(function (s) {
      if (s.dataset.ok) return; s.dataset.ok = '1';
      var cats = s.querySelectorAll('.capini-side__cat');
      cats.forEach(function (c) {
        function pick() {
          var i = c.getAttribute('data-cat');
          cats.forEach(function (o) { o.classList.toggle('is-on', o === c); });
          s.querySelectorAll('[data-cat-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-cat-panel') !== i; });
          s.querySelectorAll('[data-cat-promo]').forEach(function (p) { p.hidden = p.getAttribute('data-cat-promo') !== i; });
        }
        c.addEventListener('mouseenter', pick); c.addEventListener('focusin', pick);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
